<template>
	<div>
		<CList :pConfigList="ConfigList" :segurity="segurity">
			<template slot="bodyForm">
			<CLoader :pConfigLoad="ConfigLoad">
        		<template slot="BodyFormLoad">
				<form id="FormAgente" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
					<div class="container-fluid">
						<div class="row">
							<div class="col-12 col-sm-12 col-md-12 col-lg-12">
								<div class="form-group row">
									<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
										<label for="NombreComercial">Nombre Comercial</label>
										<input type="text" v-model="objAgente.NombreComercial" class="form-control" id="NombreComercial" placeholder="Ingresar Nombre Comercial" />
										<CValidation v-if="this.errorvalidacion.NombreComercial" :Mensaje="'*'+errorvalidacion.NombreComercial[0]"/>
									</div>
									
									<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
										<label for="RazonSocial">Razón Social</label>
										<input type="text" v-model="objAgente.RazonSocial" class="form-control" id="RazonSocial" placeholder="Ingresar Razón Social" />
										<CValidation v-if="this.errorvalidacion.RazonSocial" :Mensaje="'*'+errorvalidacion.RazonSocial[0]"/>
									</div>
								</div>
		
								<div class="form-group row">
									<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
										<label for="RegimenFiscal">Régimen Fiscal</label>
										<select class="form-control form-select" v-model="objAgente.RegimenFiscal" id="RegimenFiscal">
											<option value="">Seleccione una opción</option>
											<option v-for="(item,index) in RegimenesFiscales" :key="index" :value="item.Clave+'~'+item.Nombre">
												{{ item.Clave+' - '+item.Nombre }}
											</option>
										</select>
										<CValidation v-if="this.errorvalidacion.RegimenFiscal" :Mensaje="'*'+errorvalidacion.RegimenFiscal[0]"/>
									</div>
									
									<div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
										<label for="RFC">RFC</label>
										<input type="text" v-model="objAgente.RFC" class="form-control" id="RFC" placeholder="Ingresar RFC" />
										<CValidation v-if="this.errorvalidacion.RFC" :Mensaje="'*'+errorvalidacion.RFC[0]"/>
									</div>
									
									<div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
										<label for="Calle">Calle</label>
										<input type="text" v-model="objAgente.Calle" class="form-control" id="Calle" placeholder="Ingresar Calle" />
										<CValidation v-if="this.errorvalidacion.Calle" :Mensaje="'*'+errorvalidacion.Calle[0]"/>
									</div>
								</div>
		
								<div class="form-group row">
									<div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
										<label for="NumInt">N° Interior</label>
										<input type="text" v-model="objAgente.NumInt" class="form-control" id="NumInt" placeholder="Ingresar N° Interior" />
										<CValidation v-if="this.errorvalidacion.NumInt" :Mensaje="'*'+errorvalidacion.NumInt[0]"/>
									</div>
									
									<div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
										<label for="NumExt">N° Exterior</label>
										<input type="text" v-model="objAgente.NumExt" class="form-control" id="NumExt" placeholder="Ingresar N° Exterior" />
										<CValidation v-if="this.errorvalidacion.NumExt" :Mensaje="'*'+errorvalidacion.NumExt[0]"/>
									</div>
									
									<div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
										<label for="Colonia">Colonia</label>
										<input type="text" v-model="objAgente.Colonia" class="form-control" id="Colonia" placeholder="Ingresar Colonia" />
										<CValidation v-if="this.errorvalidacion.Colonia" :Mensaje="'*'+errorvalidacion.Colonia[0]"/>
									</div>
									
									<div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
										<label for="Cruzamientos">Cruzamientos</label>
										<input type="text" v-model="objAgente.Cruzamientos" class="form-control" id="Cruzamientos" placeholder="Ingresar Cruzamientos" />
										<CValidation v-if="this.errorvalidacion.Cruzamientos" :Mensaje="'*'+errorvalidacion.Cruzamientos[0]"/>
									</div>
								</div>
		
								<div class="form-group row">
									<div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
										<label for="CP">Código Postal</label>
										<input type="text" v-model="objAgente.CP" class="form-control" id="CP" placeholder="Ingresar Código Postal" />
										<CValidation v-if="this.errorvalidacion.CP" :Mensaje="'*'+errorvalidacion.CP[0]"/>
									</div>
									
									<div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
										<label for="Pais">País</label>
										<input type="text" v-model="objAgente.Pais" class="form-control" id="Pais" placeholder="Ingresar País" />
										<CValidation v-if="this.errorvalidacion.Pais" :Mensaje="'*'+errorvalidacion.Pais[0]"/>
									</div>
									
									<div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
										<label for="Estado">Estado</label>
										<input type="text" v-model="objAgente.Estado" class="form-control" id="Estado" placeholder="Ingresar Estado" />
										<CValidation v-if="this.errorvalidacion.Estado" :Mensaje="'*'+errorvalidacion.Estado[0]"/>
									</div>
									
									<div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
										<label for="Municipio">Municipio</label>
										<input type="text" v-model="objAgente.Municipio" class="form-control" id="Municipio" placeholder="Ingresar Municipio" />
										<CValidation v-if="this.errorvalidacion.Municipio" :Mensaje="'*'+errorvalidacion.Municipio[0]"/>
									</div>
								</div>

										
								<div class="form-group row">
									<div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
										<label for="Telefono">Teléfono</label>
										<input type="text" v-model="objAgente.Telefono" class="form-control" id="Telefono" placeholder="Ingresar Teléfono" />
										<CValidation v-if="this.errorvalidacion.Telefono" :Mensaje="'*'+errorvalidacion.Telefono[0]"/>
									</div>
									
									<div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
										<label for="Email">Email</label>
										<input type="text" v-model="objAgente.Email" class="form-control" id="Email" placeholder="Ingresar Email" />
										<CValidation v-if="this.errorvalidacion.Email" :Mensaje="'*'+errorvalidacion.Email[0]"/>
									</div>

									<div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
										<label for="DiasCredito">Días de Crédito</label>
										<input type="text" v-model="objAgente.DiasCredito" @input="$onlyNums($event,objAgente,'DiasCredito')" class="form-control" id="DiasCredito" placeholder="Ingresar Días de Crédito" />
										<CValidation v-if="this.errorvalidacion.DiasCredito" :Mensaje="'*'+errorvalidacion.DiasCredito[0]"/>
									</div>
									
									<div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
										<label for="DescuentoFlor">% Descuento Flor</label>
										<input type="text" v-model="objAgente.DescuentoFlor" @input="$onlyNums($event,objAgente,'DescuentoFlor')" class="form-control" id="DescuentoFlor" placeholder="Ingresar Descuento Flor" />
										<CValidation v-if="this.errorvalidacion.DescuentoFlor" :Mensaje="'*'+errorvalidacion.DescuentoFlor[0]"/>
									</div>

									<div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
										<label for="SerieFolio">Serie Folio</label>
										<input type="text" v-model="objAgente.SerieFolio" class="form-control" id="SerieFolio" placeholder="Ingresar Serie Folio" />
										<CValidation v-if="this.errorvalidacion.SerieFolio" :Mensaje="'*'+errorvalidacion.SerieFolio[0]"/>
									</div>
								</div>

								<div class="form-group row">
									<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
										<label for="TipoAgente">Tipo</label>
										<select @change="EvaluarTipo(objAgente.TipoAgente)" v-model="objAgente.TipoAgente" class="form-control form-select" id="TipoAgente">
											<option value="0">Seleccione una opción</option>
											<option value="1">Hotel con Comisión</option>
											<option value="2">Hotel sin Comisión</option>
											<option value="3">Independiente</option>
										</select>
										<CValidation v-if="this.errorvalidacion.TipoAgente" :Mensaje="'*'+errorvalidacion.TipoAgente[0]"/>
									</div>

									<div v-if="MostrarComision" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
										<label for="Comisiones">% Comisiones</label>
										<treeselect
										:options="Comisiones"
										:placeholder="'Selecciona la Comision'"
										v-model="objAgente.Comision"
										><h6 slot="before-list">Seleccione las comisiones</h6>
										</treeselect>
										<CValidation v-if="this.errorvalidacion.Comision" :Mensaje="'*'+errorvalidacion.Comision[0]"/>
									</div>
								</div>

								<br>
								<CBtnSave :poBtnSave="oBtnSave" />

							</div><!--fin col-12-->
						</div>
                    </div>
                </form>
				</template>
    		</CLoader>
            </template>
        </CList>
    </div>
   
</template>
<script>

const EmitEjecuta = 'seccionAgente';

export default {
    name: 'FormAgente',
    props: ['Id'],
    components:{
    },
    data() {
        return {
			ConfigList:{
                Title: 'Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				TitleFirst: 'Hotel & Empresas',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'hotelEmpresa',
                EmitSeccion: EmitEjecuta,
            },
            objAgente: {
				IdAgente: 0,
				NombreComercial: '',
				RazonSocial: '',
				RegimenFiscal: '',
				RFC: '',
				Calle: '',
				NumInt: '',
				NumExt: '',
				Colonia: '',
				Cruzamientos: '',
				CP: '',
				Pais: '',
				Estado: '',
				Municipio: '',
				Telefono: '',
				Email: '',
				TipoAgente: 0,
				Comision: null,
				ImgHotel: '',
				CorreosCC: '',
				DiasCredito: '',
				DescuentoFlor: '',
				FechaRegistro: '',
				SerieFolio: '',
				Matriz: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				ComisionesxAgente:[]
				
            },
            segurity: {},
			masks: { input: 'YYYY-MM-DD' }, // quitar sino lleva fecha 
            errorvalidacion: [],
			Emit: EmitEjecuta,
			// Datos personalizados
			MostrarComision:false,
			Comisiones:[],
			RegimenesFiscales:[]
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
			// this.objAgente.ComisionesxAgente=JSON.stringify(this.objAgente.ComisionesxAgente);

			if(this.objAgente.IdAgente == 0) {
				await this.$http.post(
					'agentes',this.objAgente
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'agentes/'+this.objAgente.IdAgente,
					this.objAgente
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
			this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
			
        },
        EjecutaConError(err)
        {
			// this.objAgente.ComisionesxAgente=JSON.parse(this.objAgente.ComisionesxAgente);
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                // "agentes/recovery.api",
                // {
                //     params:{IdAgente:this.objAgente.IdAgente}
                // }
				"/agentes/"+this.objAgente.IdAgente
            ).then((res) => {
                this.objAgente = res.data.data;
				this.RecuperarComisiones(this.objAgente.IdAgente);

            })
			// .finally(()=>{
            //     this.ConfigLoad.ShowLoader = false;
            // });
        },
        Limpiar()
        {
            this.objAgente = {
				IdAgente: 0,
				NombreComercial: '',
				RazonSocial: '',
				RegimenFiscal: '',
				RFC: '',
				Calle: '',
				NumInt: '',
				NumExt: '',
				Colonia: '',
				Cruzamientos: '',
				CP: '',
				Pais: '',
				Estado: '',
				Municipio: '',
				Telefono: '',
				Email: '',
				TipoAgente: 0,
				Comision: null,
				ImgHotel: '',
				CorreosCC: '',
				DiasCredito: '',
				DescuentoFlor: '',
				FechaRegistro: '',
				SerieFolio: '',
				Matriz: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				ComisionesxAgente:[]
				
            }
            this.errorvalidacion = [];
			this.MostrarComision=false;
        },
		Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute});
            // this.$router.push({name:'routeraregresar',params:{obj:this.obj}});
        },
		// METODOS PROPIOS
		ListarComisiones(){
			this.$http.get('/comisionesSimple').then((res)=>{
				this.Comisiones=res.data.data.map(function(obj){
					return{
						id:obj.Cantidad,
						label:obj.Cantidad+'%'
					}
				});
			})
		},
		EvaluarTipo(Tipo){
			if (Tipo==1) {
				this.MostrarComision=true;
				this.Comisiones.forEach((el)=>el.isDisabled=false);
			}
			else{
				this.MostrarComision=false;
				this.objAgente.ComisionesxAgente=[];
			}
		},
		async RecuperarComisiones(IdAgente){
			await this.$http.get("/comisionesxagente",{
				params:{
					IdAgente:IdAgente
				}
			}).then((res)=>{
				this.objAgente.ComisionesxAgente=res.data.data.map(function(el){
					return el.IdComision;
				});
				this.Comisiones.forEach(element => {
					this.objAgente.ComisionesxAgente.forEach(el=>{
						if (element.id==el) {
							element.isDisabled=true;
						}
					})
				});
				if (this.objAgente.TipoAgente==1) {
					this.MostrarComision=true;
				}
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		async RecuperarRegimenFiscal(){
			await this.$http.get('regimenesfiscales',{
				params:{
					Simple:1
				}
			}).then((res)=>{
				this.RegimenesFiscales = res.data.data;
			})
		}
    },
	created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();

        if(this.Id!='') 
        {
            this.objAgente.IdAgente = this.Id;
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

		this.ListarComisiones();
		this.RecuperarRegimenFiscal();
    }
}
</script>
